export const LOGO_URL = "/flowsphere-logo-transparent.png";

export const PLANS = [
  {
    id: "basic",
    name: "Starter",
    price: 4999,
    tagline: "Everything a growing business needs to invoice and track inventory.",
    features: [
      "Unlimited invoices with GST",
      "Customer & supplier management",
      "Inventory + purchase orders",
      "Expenses, payments, reports",
      "Printable & downloadable invoices",
      "Priority email support",
    ],
  },
  {
    id: "pro",
    name: "Pro",
    price: 9999,
    tagline: "Automate the tedious parts of running your business.",
    highlight: true,
    features: [
      "Everything in Starter, plus:",
      "Automated WhatsApp reminders & follow-ups",
      "Daily manual price updates per product",
      "Automatic inventory revaluation on price change",
      "Full price history & movement charts",
      "Bring-your-own WhatsApp API credentials",
    ],
  },
];
